<template>
  <div>
    <label for="lastName">{{ $t('questionForm.lastName.title') }}</label>
    <v-text-field
      id="lastName"
      v-model="lastName"
      solo
      flat
      hide-details="auto"
      :class="{
        'is-valid':
          !disabled && lastName && lastName.length && $v.lastName.$dirty && !$v.lastName.$invalid
      }"
      :error="!disabled && $v.lastName.$error"
      :error-messages="$v.lastName.$error ? $t('questionForm.lastName.errorText') : ''"
      :placeholder="placeholder || ''"
      :disabled="disabled"
      :messages="$t('questionForm.lastName.helpTextRealData')"
      @click="sendGtmEvent('Příjmení')"
      @blur="$v.lastName.$dirty || (lastName && lastName.length) ? $v.lastName.$touch() : null"
    >
      <template v-if="!disabled" #append>
        <v-icon v-if="lastName && lastName.length && $v.lastName.$dirty && !$v.lastName.$error">
          $tick
        </v-icon>
        <v-icon v-if="$v.lastName.$error"> $warning </v-icon>
      </template>
    </v-text-field>
  </div>
</template>

<script>
import formValidation from '@/mixins/formValidation';
import formGtm from '@/mixins/formGtm';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'LastName',
  mixins: [formValidation, formGtm],
  props: {
    placeholder: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  validations() {
    let validation = { lastName: {} };
    if (this.required) {
      validation.lastName = { required };
    }
    return validation;
  },
  computed: {
    lastName: {
      get() {
        return this.$store.state.forms.lastName.lastName;
      },
      set(value) {
        this.$store.commit('forms/lastName/updateLastName', value);
      }
    }
  },
  created() {
    this.$eventHub.$on('validateLastName', done => this.validateForm(done, 'forms/lastName'));
  },
  destroyed() {
    this.$eventHub.$off('validateLastName');
  }
};
</script>
